import { createApi } from "@reduxjs/toolkit/query/react";
import { reservationEndpoint, roomsEndpoint } from "routes/api/endpoints"
import { customFetchBaseQuery } from "./auth/queries";

export const reservationApi = createApi({
    reducerPath: "reservationApi",
    baseQuery: customFetchBaseQuery(),
    endpoints: (builder) => ({
        addNewReservation: builder.mutation({
            query: (reservationData) => ({
                url: reservationEndpoint.addNewReservation(),
                method: "POST",
                body: reservationData,
            }),
        }),
        getReservations: builder.query({
            query: (userId) => ({
                url: reservationEndpoint.addNewReservation(),
                method: "GET",
                params: { user: userId },
            }),
        }),
        getRooms: builder.query({
            query: (userId) => ({
                url: roomsEndpoint.getRooms(),
                method: "GET",
                params: { user: userId },
            }),
        }),
    }),
});

export const { useAddNewReservationMutation, useGetRoomsQuery, useGetReservationsQuery } = reservationApi;